import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=a81f06ee&scoped=true"
import script from "./GDPR.vue?vue&type=script&lang=js"
export * from "./GDPR.vue?vue&type=script&lang=js"
import style0 from "./GDPR.vue?vue&type=style&index=0&id=a81f06ee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81f06ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a81f06ee')) {
      api.createRecord('a81f06ee', component.options)
    } else {
      api.reload('a81f06ee', component.options)
    }
    module.hot.accept("./GDPR.vue?vue&type=template&id=a81f06ee&scoped=true", function () {
      api.rerender('a81f06ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/GDPR.vue"
export default component.exports